import { render, staticRenderFns } from "./closePriceDtl.vue?vue&type=template&id=2324fef1&scoped=true&"
import script from "./closePriceDtl.vue?vue&type=script&lang=js&"
export * from "./closePriceDtl.vue?vue&type=script&lang=js&"
import style0 from "./closePriceDtl.vue?vue&type=style&index=0&id=2324fef1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2324fef1",
  null
  
)

export default component.exports